import authenticate from '@/middleware/authenticate'
import apiDivision from '@/api/administration/division'

export default [
  {
    path: '/divisions',
    name: 'division',
    meta: { middleware: authenticate },
    component: () => import('@/pages/administration/division/index.vue')
  },
  {
    path: '/divisions/:id',
    name: 'division-edit',
    meta: { middleware: authenticate },
    component: () => import('@/pages/administration/division/index.vue'),
    props: route => ({ editData: route.params.editData }),
    beforeEnter: async (to, from, next) => {
      let response = await apiDivision.find(to.params.id)
      to.params.editData = response.data
      next()
    }
  }
]
